import { isString } from "lodash";

export const isPresent = val => isString(val) && val.length > 0;

const reEmail = /^([a-zA-Z0-9+_.-]+)@([a-zA-Z0-9+_.-]+)\.([a-zA-Z]{2,12})$/;
export const isEmail = val => reEmail.test(val);

const reZip = /^\d{5}(?:[-\s]\d{4})?$/;
export const isZip = val => reZip.test(val);

export function isCheckNumberValid(checkNum) {
  const pattern = /^[0-9]*$/;

  return pattern.test(checkNum);
}

export function isAccountValid(accountNum) {
  const pattern = /^[0-9]*$/;

  return pattern.test(accountNum);
}

export function isRoutingValid(routingNum) {
  const pattern = /^[0-9]{9}$/;

  return pattern.test(routingNum);
}

export function isValidCard(cardNumber) {
  const pattern = /^\d{15,16}$/;

  return pattern.test(cardNumber);
}

export function isValidMonth(month) {
  return month ? month <= 12 && month > 0 : false;
}

export function isValidYear(year) {
  return year ? year >= new Date().getFullYear() : false;
}

export function isValidExpirationDate(month, year) {
  const today = new Date();
  const currentMonth = today.getMonth() + 1;
  const currentYear = today.getFullYear();
  const monthVal = parseInt(month);
  const yearVal = parseInt(year);

  if (!month || !year) {
    return false;
  }

  return yearVal === currentYear
    ? monthVal >= currentMonth
      ? isValidMonth(monthVal)
      : false
    : isValidYear(yearVal) && isValidMonth(monthVal);
}

/**
 * Password policy:
 * - must contain at least one:
 *    -lowercase letter
 *    - uppercase letter
 *    - number
 *    - special character
 * - must be 12 characters or more in length
 * - must match confirmation password.
 */
export const validatePassword = ({
  newPassword,
  confirmPassword,
  errors = {}
}) => {
  const missingNum = !/[\d]/.test(newPassword);
  const missingUppercase = !/[A-Z]/.test(newPassword);
  const invalidLength = newPassword.length < 12;
  const doesNotMatchConfirmPW = newPassword !== confirmPassword;
  const missingSpecialChars = !/[#?!@$ %^&*-]/.test(newPassword);

  if (missingNum) {
    errors.missingNum = "Must contain at least one number";
  }

  if (missingUppercase) {
    errors.missingUppercase = "Must contain at least one uppercase character";
  }

  if (invalidLength) {
    errors.invalidLength = "Must be at least 12 characters";
  }

  if (missingSpecialChars) {
    errors.missingSpecialChars = "Must contain at least one special character";
  }

  if (doesNotMatchConfirmPW) {
    errors.doesNotMatchConfirmPW = "New and Confirm Password must match";
  }

  return errors;
};

export const validatePasswordUserServices = ({
  newPassword,
  confirmPassword,
  errors = {}
}) => {
  const missingNum = !/[\d]/.test(newPassword);
  const missingUppercase = !/[A-Z]/.test(newPassword);
  const missingLowerCase = !/[a-z]/.test(newPassword);
  const invalidLength = newPassword.length < 14;
  const missingSpecialChars = !/[#?!@$ %^&*-]/.test(newPassword);
  const doesNotMatchConfirmPW = newPassword !== confirmPassword;
  const invalidChar = /["'\\]/.test(newPassword);

  if (missingNum) {
    errors.missingNum = "Must contain at least one number";
  }
  if (missingUppercase) {
    errors.missingUppercase = "Must contain at least one uppercase character";
  }
  if (invalidLength) {
    errors.invalidLength = "Must be at least 14 characters";
  }
  if (missingSpecialChars) {
    errors.missingSpecialChars = "Must contain at least one special character";
  }
  if (doesNotMatchConfirmPW) {
    errors.doesNotMatchConfirmPW = "New and Confirm Password must match";
  }
  if (missingLowerCase) {
    errors.missingLowerCase = "Must contain at least one lowercase character";
  }
  if (invalidChar) {
    errors.invalidChar = "Cannot contain \", ', or \\ characters";
  }

  return errors;
};
